export function toggleFormVisibility(){
    return{
        type: "TOGGLE_FORM"
    };
}
